@if (isFormControlReady) {
  <form class="form-group" [formGroup]="formGroupInput" [class.has-label]="label">
    @if (label) {
      <label for="disaggregations-select">{{ label | translate }} {{ level }}</label>
    }
    <p-treeSelect
      id="disaggregations-select"
      [(ngModel)]="selectedNodes"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onSelectionChange($event)"
      [options]="treeNodes"
      [filter]="true"
      (onClear)="clearFilter()"
      [showClear]="true"
      [loading]="loading"
      fluid
      selectionMode="checkbox"
      [metaKeySelection]="false"
      display="chip"
      [scrollHeight]="'150px'"
      size="small"
      appendTo="body"
    >
      <ng-template let-node pTemplate="default">
        <div style="font-size: 12px; white-space: normal; word-break: break-word; line-height: 1.4">
          {{ node.label }}
        </div>
      </ng-template>
    </p-treeSelect>
  </form>
}
